<template>
  <v-layout class="map-container" fill-height v-resize="resizeMap">    
      <map-control :uiid="uiid" />
      <mission-map :uiid="uiid" ref="map" >
        <slot></slot>
      </mission-map>                   
  </v-layout>
</template>
<script>
import MissionMap from '@/components/map/MissionMap'
import MapControl from '@/components/map/MapControl'
  export default {
    name: 'GlobalMission',   
    components:{MissionMap,MapControl}, 
    props:{
      uiid:{
          type: String,
          default: 'map_global'
      }
    },
    mounted() {          
      setTimeout(() => this.resizeMap(),2000)
    },
    methods: {           
      resizeMap(){                
        if(this.$refs.map) this.$refs.map.updateSize()        
      }
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>
.map-container{
  position: absolute;
  top: 0; bottom: 0; left: 0; right: 0;
}
</style>
